import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { computed, MaybeRef, toValue } from 'vue'
import { whenAuthenticatedAnd } from '@/utils/query-utils'

export const useDashboardNotificationsQuery = (
    componentType: MaybeRef<number | null>,
    notificationTypes: MaybeRef<number[]>,
    pastDays: MaybeRef<number>,
) => {
    const queryKey = computed(() => [
        'dashboard',
        'notifications',
        toValue(componentType),
        [...toValue(notificationTypes)],
        toValue(pastDays),
    ])

    return useQuery({
        queryKey,
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.dashboardApi.listEvents(
                toValue(componentType as number),
                undefined,
                undefined,
                toValue(notificationTypes),
                toValue(pastDays),
                0,
                0,
                undefined,
                undefined,
                undefined,
                { signal },
            )
            return result
        },
        enabled: whenAuthenticatedAnd(computed(() => !!toValue(componentType))),
    })
}
